const axios = require('axios');

const RocketHttpAssets = {
  axios,
};

export function setRocketHttpAssets(key, obj) {
  if (RocketHttpAssets[key]) return;
  RocketHttpAssets[key] = obj;
}
export function getRocketHttpAssets(key) {
  return RocketHttpAssets[key] || RocketHttpAssets.axios;
}
export default RocketHttpAssets;
